// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Box, Form } from 'grommet'
import PropTypes from 'prop-types'
import { CircleAlert } from 'grommet-icons'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { Typography } from '../typography/Typography'

export const FormOverallAlert = ({ message }) => {
  const LDFlags = useFlags()
  const showTransferWkspcToMSPAction = LDFlags['glcp-msp-managed-transfer']

  return (
    <Box
      background="rgba(252, 97, 97, 0.24)"
      pad="small"
      round="4px"
      // Relies on the form child to provide a bottom margin that is between itself
      // and the buttons or this error. This setting will then provide
      // a margin between the error message and the buttons.
      margin={{ bottom: 'medium' }}
      gap="xsmall"
      direction="row"
      align={!showTransferWkspcToMSPAction ? 'center' : 'baseline'}
      data-testid="form-global-error"
    >
      <CircleAlert size="small" />
      <Typography type="text" size="xsmall" testId="form-global-error-message">
        {message}
      </Typography>
    </Box>
  )
}
FormOverallAlert.propTypes = {
  message: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired
}

export const CCSForm = ({
  testId,
  buttons = <></>,
  children = <></>,
  errorMessage,
  ...rest
}) => {
  return (
    <Form data-testid={testId} {...rest}>
      {children}
      {typeof errorMessage === 'string' ? (
        errorMessage?.length > 0 && <FormOverallAlert message={errorMessage} />
      ) : (
        <FormOverallAlert message={errorMessage} />
      )}
      {buttons}
    </Form>
  )
}

CCSForm.propTypes = {
  children: PropTypes.element,
  testId: PropTypes.string.isRequired,
  buttons: PropTypes.element,
  errorMessage: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired
}
